import { PriceChange } from './price-change';
import { Product } from './product';
import { ProductType } from './product-type';
import { TranslatedText, Translation } from './translated-text';

export class ProductCustomisable extends Product {
  public customise: any;

  constructor(
    id: string,
    sku: string,
    name: string | TranslatedText,
    description: string | TranslatedText,
    price: number,
    priceChanges: PriceChange[],
    order: any,
    energyInformation: string,
    imageUrl: string,
    isVisible = true,
    categoryId: string,
    isAvailable = true,
    originalImageUrl: string,
    customise: any,
    posItemId: number,
    nameTranslations?: Translation[],
    serves?: string | TranslatedText,
  ) {
    super(
      id,
      sku,
      name,
      description,
      price,
      priceChanges,
      order,
      energyInformation,
      imageUrl,
      isVisible,
      categoryId,
      isAvailable,
      originalImageUrl,
      posItemId,
      nameTranslations,
      serves,
    );

    this.type = ProductType.CUSTOMISE;
    this.customise = customise;
    this.providerData = {};
  }
}
